import { Box, Typography } from '@mui/material';
import { Outlet } from 'react-router';
import { AdminNav } from '../../components/AdminNav';
import { ADMIN_KEYS_PATH, ADMIN_REPOSITORIES_PATH, ADMIN_SYNC_PATH, ADMIN_USERS_PATH } from '../../config';
import { contentWidthSx, pageGutterSx, sectionSpacingSx } from '../../theme';

const SECTIONS = [
  { label: 'Repositories', to: ADMIN_REPOSITORIES_PATH },
  { label: 'Access keys', to: ADMIN_KEYS_PATH },
  { label: 'Users', to: ADMIN_USERS_PATH },
  { label: 'Syncs', to: ADMIN_SYNC_PATH },
];

/**
 * The frame every `/admin` page renders inside: the gutters, the width cap, the name of
 * the area and the tabs between its four pages.
 *
 * **Behind two checks, and neither is here.** `RequireAdmin` keeps a non-admin from
 * drawing any of them, and every route they call needs the `admin` scope at the gateway.
 * The add pages sit beside this layout rather than in it, because each is a form with a
 * page of its own.
 */
export const AdminLayout = () => (
  <Box sx={pageGutterSx}>
    <Box sx={{ ...contentWidthSx, paddingBlock: 12 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        <Typography variant="overline" component="p" sx={{ color: 'text.secondary', letterSpacing: '1px' }}>
          Admin
        </Typography>
        <AdminNav items={SECTIONS} />
      </Box>

      <Box sx={sectionSpacingSx}>
        <Outlet />
      </Box>
    </Box>
  </Box>
);
